import { Helmet } from 'react-helmet-async';
import { PhysicalSettingsView } from 'src/sections/physicalSettings/view';

export default function PhysicalSettingsPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Settings</title>
      </Helmet>

      <PhysicalSettingsView />
    </>
  );
}
